import React from 'react';
import Config from '../../../../../Config';
import Property from '@episerver/spa-core/Components/Property';
import CheckBox from '../../../../Shared/CheckBox/Checkbox';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';

const Products = (props) => {


    return (
        <div className='main'>
            <h3 className='title-black'>מה נעביר לכתובת החדשה?</h3>
            <div className='productsList'>
                <div>
                    {props.products?.map((item, index) => {
                        const isSelected = props.selectedProducts.find(x => x.productId == item.productId);
                        return (
                            <div className={`product ${isSelected ? "selected" : ''}`} key={index}>
                                <div className='product-checkbox'>
                                    <CheckBox
                                        id={'id-' + index}
                                        onCheck={() => props.onClickCheckbox(true, item)}
                                        onUncheck={() => props.onClickCheckbox(false, item)}
                                        checked={isSelected}
                                        label={''}
                                    >
                                    </CheckBox>
                                    <div className='product-checkbox-title'>
                                        {item.bundleType == "Triple" || item.bundleType == "Quattro" ?
                                            <>
                                                <div><b>{item.bundleType == "Triple" ? "טריפל : " : "קוואטרו :"} {item.productDescription}</b></div>
                                                <div>מאיפה מעבירים? {item.fullAddress}</div>
                                            </>
                                            :
                                            <>
                                                <div><b>{item.productDescription}</b></div>
                                                {item.productType == "TV" && <div>{item.email}</div>}
                                                {item.productType == "Mapa" && <div>{item.phoneNumber}</div>}
                                                {(item.fullAddress && (item.productType != "TV" || item.productType == "TV" && item.equipment)) &&  <div>מאיפה מעבירים? {item.fullAddress}</div>}
                                            </>
                                        }
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        </div>

    );
};
export default Products;
